import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, concatMap } from 'rxjs/operators';
import { PanelDataService } from '../../../../../utils/src/lib/sysque-backend/panel-data.service';
import {
  ChangeApplyPanelDialogSize,
  ChangeApplyPanelDialogSizeSuccess,
  ValidatePanelCircuitData,
  ValidatePanelCircuitDataSuccess,
} from './panel-data-actions';

@Injectable()
export class ApplyPanelDataEffects {
  constructor(
    private readonly actions$: Actions,
    private panelService: PanelDataService
  ) {}

  validatePanelData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidatePanelCircuitData),
      mergeMap(() =>
        this.panelService.validatePanelCircuitData().pipe(
          map(response => ValidatePanelCircuitDataSuccess({ response }))
        )
      )
    )
  );

  changeDialogDimensions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeApplyPanelDialogSize),
      concatMap(({ height }) =>
        this.panelService.changeDialogDimensions(height).pipe(
          map(response => response && ChangeApplyPanelDialogSizeSuccess({ response }))
        )
      )
    )
  );
}
